const ELEMENT_ID_THEME = 'theme';

const PRIMARY_COLOR_MAP: Record<string, string> = {
  'cdx-theme-green': '#50C135',
  'cdx-theme-blue': '#1577b8',
  'cdx-theme-cyan': '#1ea0f3',
  'cdx-theme-sea-green': '#05ac85',
  'cdx-theme-dark-green': '#21423e',
  'cdx-theme-yellow': '#ffad19',
  'cdx-theme-coral': '#f35d22',
  'cdx-theme-red': '#dc0000',
  'cdx-theme-cherry': '#e0245e',
  'cdx-theme-purple': '#7b4ac4',
  'cdx-theme-black': '#0b0b0b'
};


export class CodexComponentColor {

    private static getTheme() {
        return document.getElementById(ELEMENT_ID_THEME);
    }

    public static getPrimaryColor(): string {
      const themeElement = this.getTheme();
      if (!themeElement) return PRIMARY_COLOR_MAP['cdx-theme-black'];
    
      const themeClass = Object.keys(PRIMARY_COLOR_MAP).find((cls) =>
        themeElement.classList.contains(cls)
      );
    
      return themeClass ? PRIMARY_COLOR_MAP[themeClass] : PRIMARY_COLOR_MAP['cdx-theme-black'];
    }
}